<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                :title="details ? 'Position bearbeiten' : 'Neue Position anlegen'"
                :loading="loading"
                @click:outside="close"
                @ok="submit"
                @cancel="close"
        >
            <template v-slot:button v-if="details">
                <Button :text="true" :color="ada.red" v-if="!$store.state.readOnly"
                        @click="showDeleteDialog = true">
                    Löschen
                </Button>
            </template>
            <v-row>
                <v-col cols="12">
                    <Input :hide-details="true" v-model.trim="name" label="Bezeichnung"></Input>
                </v-col>
            </v-row>
        </Dialog>
        <DeletePositionDialog v-model="showDeleteDialog" @deleted="close"></DeletePositionDialog>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Input from "../../../components/Inputs/Input";
import Button from "../../../components/buttons/Button";
import ada from "../../../scss/ada_colors.scss";
import DeletePositionDialog from "../../Settings/Dialogs/DeletePositionDialog";

export default {
    name: "AddEditPositionDialog",
    props: ['value'],
    components: {DeletePositionDialog, Button, Input, Dialog},
    data: () => {
        return {
            name: null,
            loading: false,
            showDeleteDialog: false,
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        details() {
            return this.$store.state.settings.selectedDetails;
        },
    },
    methods: {
        init() {
            if (this.details) {
                this.name = this.details.Name;
            } else {
                this.name = null;
            }
        }
        ,
        async submit() {
            this.loading = true;
            try {
                let data = await this.$store.dispatch('settings/editPosition', this.getBody());
                this.loading = false;
                if (data.Status) {
                    let msg = this.details ? 'Erfolgreich gespeichert.' : 'Position erfolgreich angelegt.';
                    this.$root.$emit('snackbar', msg);
                    this.close();
                }
            } catch (e) {
                this.loading = false;
            }
        },
        getBody() {
            let json = {
                Name: this.name,
            };
            if (this.details) json.position_id = this.details.ConfigPositionnameId;
            return json;
        },
        close() {
            this.$store.commit('settings/resetSelected');
            this.init();
            this.$emit('input', false); // set v-model to false -> close dialog
        },
    }
    ,
    watch: {
        details() {
            if (this.$store.state.settings.activeTab === 'Settings_Position') this.init();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>